import { render, staticRenderFns } from "./CommercialConfiguration.vue?vue&type=template&id=c8cb756c&"
import script from "./CommercialConfiguration.vue?vue&type=script&lang=js&"
export * from "./CommercialConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CommercialConfiguration.vue"
export default component.exports